import { render, staticRenderFns } from "./BaseColorPicker.vue?vue&type=template&id=72666ee3&scoped=true"
import script from "./BaseColorPicker.vue?vue&type=script&lang=js"
export * from "./BaseColorPicker.vue?vue&type=script&lang=js"
import style0 from "./BaseColorPicker.vue?vue&type=style&index=0&id=72666ee3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72666ee3",
  null
  
)

export default component.exports